/* eslint-disable */

export enum ChangeContactInfoEnum {
	Undefined = 0,
	UseOrderData = 1,
	InputNewContact = 2,
	
}
